<template>
<div class="con-speaker">
  <div class="container" v-if="speaker">
    <div class="avatar">
      <img :src="speaker.avatar+'?imageView2/0/w/800'">
    </div>
    <div class="right">
      <h1><b>{{speaker.is_previous?'往届':''}}{{speakerConfig[speaker.typeId] && speakerConfig[speaker.typeId].name}}：</b>{{speaker.name}}</h1>
      <h6>
        <span class="item">{{speaker.company}}</span>
        <span class="item">{{speaker.position}}</span>
        <a v-if="lecture && lecture.pptLink" :href="lecture.pptLink" target="_blank" class="item ppt display-pc"><i class="iconfont icon-ppt"></i></a>
      </h6>
      <div class="content" v-html="speaker.introduce">
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: [
    'speaker-config',
    'speaker',
    'lecture'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.con-speaker
  background-color: #f5f7f8
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .avatar
    width: 345px
    padding-left: 30px
    flex-shrink: 0
    +mobile
      padding-left: 0
      width: 100%
      text-align: center
  .avatar img
    width: 237px
    height: 237px
    padding: 5px
    border: 1px solid #f4f6f7
    // border: 2px solid #777777
    border-radius: 50%
    background-color: #fff
    +mobile
      width: 43vw
      height: 43vw
  .right
    flex-grow: 1
    .item:first-of-type
      margin-right: 10px
  h1
    font-size: 38px
    color: #3e3a39
    +mobile
      text-align: center
      font-size: 15px
      color: var(--primary-color)
      margin-top: 10px
  h6
    margin-top: 8px
    margin-bottom: 21px
    font-size: 18px
    color: #8e9ca9
    display: flex
    align-items: center
    .item.ppt
      margin-left: 20px
    .ppt
      i.iconfont
        font-size: 36px
        color: var(--primary-color)
    img
      height: 2.2em
    +mobile
      justify-content: center
      font-size: 12px
      text-align: center
      color: #898989
      margin: 10px 0 20px 0
</style>
